// ⚠️ 此文件由 scripts/gen-icon-hash.ts 自动生成，请勿手动修改
export const ICON_HASH = 'c1011028';
